class OSFPreviewCallback {
    static fontStyle(element, value, unit = '') {
        if (value.italic) {
            element.style.fontStyle = 'italic';
        } else {
            element.style.fontStyle = 'normal';
        }

        if (value.underline) {
            element.style.textDecoration = 'underline'
        } else {
            element.style.textDecoration = 'none'
        }

        if (value.fontWeight) {
            element.style.fontWeight = 'bold';
        } else {
            element.style.fontWeight = 'normal';
        }

        if (value.uppercase) {
            element.style.textTransform = 'uppercase';
        } else {
            element.style.textTransform = 'none';
        }
    }

    static fontFamily(element, value, unit = 'px') {

    }

    static labelProperty(element, value, unit = 'px') {
        let $element = $(element);
        if ($element.next().prop('tagName') === 'STYLE') {
            $element.next().remove();
        }
        let className = '.' + element.className.replace(/\s/g, '.');
        $element.after(`<style>
    ${className}{
        background: ${value};
    }
    ${className}:after{
        border-right-color: ${value};
    }
</style>`);
    }

    static addClass(element, value, prefix) {
        $(element).removeClass((index, className) => {
            let toReturn = '',
                classes  = className.split(' ');
            for (let c of classes) {
                let regex = new RegExp(`${prefix}(.)*`);
                if (regex.test(c)) {
                    toReturn += c + ' ';
                }
            }
            return toReturn
        }).addClass(`${prefix}${value}`);

        setTimeout(() => {
            OSFPreviewSectionHover.getInstance().setPosition();
        }, 200);
    }

    static contentLayout(element, value, unit = 'px') {
        OSFPreviewCallback.addClass(element, value, 'opal-layout-');
    }

    static enableSideHeader(element, value, unit = 'px'){
        if(value){
            $(element).addClass('opal-header-layout-sideHeader');
            let position = wp.customize('otf_header_layout_side_header_position').get();
            OSFPreviewCallback.addClass(element, position, 'opal-side-header-');
        }else{
            $(element).removeClass('opal-header-layout-sideHeader');
        }
    }

    static changeStyleSingleProduct(element, value, unit = '') {
        //wp.customize.previewer.refresh
        wp.customize.preview.send('opal-save-and-reload');
    }

    static changeWidthSidebar(element, value, unit = 'px') {
        $('#secondary').css({
            flex    : `0 0 ${value}px`,
            maxWidth: `${value}px`,
        });

        $('#primary').css({
            flex    : `0 0 calc(100% - ${value}px)`,
            maxWidth: `calc(100% - ${value}px)`,
        })
    }

    static reloadGoogleFont(element, value, unit = 'px') {
        if (value.family !== '') {
            let link = encodeURI(`https://fonts.googleapis.com/css?family=${value.family}:${value.fontWeight}`);
            $('head').append(`<link rel="stylesheet" href="${link}" type="text/css" media="all" />`)
        }
    }

    static chaneAddToCart(element, value, unit = 'px') {
        let $element = $(element);
        if ($element.next().prop('tagName') === 'STYLE') {
            $element.next().remove();
        }
        $element.after(`<style>
            .product a[class*="product_type_"],
            .product a[class*="product_type_"]:before{
                color: ${value} !important;
            }
        </style>`);
    }

    static chaneQuickView(element, value, unit = 'px') {
        let $element = $(element);
        if ($element.next().prop('tagName') === 'STYLE') {
            $element.next().remove();
        }
        $element.after(`<style>
            li.product .yith-wcqv-button,
            li.product .yith-wcqv-button:before{
                color: ${value} !important;
            }
        </style>`);
    }

    static chaneWishList(element, value, unit = 'px') {
        let $element = $(element);
        if ($element.next().prop('tagName') === 'STYLE') {
            $element.next().remove();
        }
        $element.after(`<style>
             li.product .yith-wcwl-add-to-wishlist > div > a,
             li.product .yith-wcwl-add-to-wishlist > div > a:before{
                color: ${value} !important;
            }
        </style>`);
    }

    static chaneCompare(element, value, unit = 'px') {
        let $element = $(element);
        if ($element.next().prop('tagName') === 'STYLE') {
            $element.next().remove();
        }
        $element.after(`<style>
             li.product .compare,
             li.product .compare:before{
                color: ${value} !important;
            }
        </style>`);
    }

    static changeBgOnSale(element, value, unit = 'px') {
        let $element = $(element);
        if ($element.next().prop('tagName') === 'STYLE') {
            $element.next().remove();
        }
        if ($('body').is('.product-style-1, .product-style-6, .product-style-7, .product-style-8, .product-style-9')) {
            $element.after(`<style>
            .product-transition .onsale:before{
                background-color: ${value}!important;
            }
            </style>`);
        } else {
            $element.css('backgroundColor', value);
        }

    }

    static changeStyleProduct(element, value, unit = '') {
        //wp.customize.previewer.refresh
        wp.customize.preview.send('opal-save-and-reload');
    }

}
